import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section className="contact section" id="contact">
      <h2 className="section_title">Get in touch</h2>
      <span className="section_subtitle">Contact me</span>

      <div className="contact_container container grid">
        <div className="contact_content">
          <h3 className="contact_title">Let's Talk!</h3>
          <div className="contact_info">
            <div className="contact_card">
              <i className="bx bx-notepad contact_card_icon"></i>

              <h3 className="contact_card_title">Medium</h3>

              <a
                href="https://medium.com/@Ruthvik_B.R"
                className="contact_button"
                target="_blank"
              >
                Read my articles
                <i className="bx bx-right-arrow-alt contact_button_icon"></i>
              </a>
            </div>

            <div className="contact_card">
              <i className="bx bxl-twitter contact_card_icon"></i>

              <h3 className="contact_card_title">Twitter</h3>
              <a
                href="https://twitter.com/RuthvikBR"
                target="_blank"
                className="contact_button"
              >
                My thoughts
                <i className="bx bx-right-arrow-alt contact_button_icon"></i>
              </a>
            </div>

            <div className="contact_card">
              <i className="bx bxl-linkedin-square contact_card_icon"></i>

              <h3 className="contact_card_title">Linkedin</h3>
              <span className="contact_card_data"></span>
              <a
                href="https://www.linkedin.com/in/ruthvikbr/"
                target="_blank"
                className="contact_button"
              >
                Follow my work
                <i className="bx bx-right-arrow-alt contact_button_icon"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="contact_content">
          <h3 className="contact_title">My work</h3>
          <div className="contact_info">
            <div className="contact_card">
              <i className="bx bxl-github contact_card_icon"></i>
              <h3 className="contact_card_title">Github</h3>
              <a
                href="https://github.com/Ruthvikbr"
                target="_blank"
                className="contact_button"
              >
                View my work
                <i className="bx bx-right-arrow-alt contact_button_icon"></i>
              </a>
            </div>
            <div className="contact_card">
              <i className="bx bxl-github contact_card_icon"></i>
              <h3 className="contact_card_title">Github Sponsors</h3>
              <a
                href="https://github.com/sponsors/Ruthvikbr"
                target="_blank"
                className="contact_button"
              >
                Support me
                <i className="bx bx-right-arrow-alt contact_button_icon"></i>
              </a>
            </div>
            <div className="contact_card">
              <i className="bx bxl-google contact_card_icon"></i>
              <h3 className="contact_card_title">Google Dev Profile</h3>
              <a
                href="https://g.dev/Ruthvikbr"
                target="_blank"
                className="contact_button"
              >
                Visit
                <i className="bx bx-right-arrow-alt contact_button_icon"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
